import { useEffect } from "react";
import { Button, Tab, Tabs } from "react-bootstrap";
import { IoArrowBackCircleSharp } from "react-icons/io5";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import BusinessCustomers from "./BusinessCustomers";
import PersonalCustomers from "./PersonalCustomers";

const CustomersTab = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const franchiseId = location.state?.franchiseId;
  const referralCode = location.state?.referralCode;

  const activeTab = searchParams.get("tab") || "personal";

  useEffect(() => {
    if (!searchParams.get("tab")) {
      setSearchParams({ tab: "personal" });
    }
  }, []);
  const handleBack = () => {
    navigate("/master-admin-dashboard/franchises");
  };

  const handleTabChange = (key) => {
    setSearchParams({ tab: key });
  };

  return (
    <div className="scrollable-container" style={{ height: "100%" }}>
      <div className="header-container">
        <h1>
          <strong>Customers</strong>
        </h1>
        <Button onClick={handleBack} variant="info" className="tooltip-btn">
          <IoArrowBackCircleSharp />
          <span className="tooltip-text">Go to Back</span>
        </Button>
      </div>

      <Tabs
        activeKey={activeTab}
        onSelect={handleTabChange}
        id="franchiseCustomers"
      >
        <Tab eventKey="personal" title="Personal Customers">
          <PersonalCustomers referralCode={referralCode} />
        </Tab>

        <Tab eventKey="business" title="Business Customers">
          <BusinessCustomers franchiseId={franchiseId} />
        </Tab>
      </Tabs>
    </div>
  );
};

export default CustomersTab;
